import { render, staticRenderFns } from "./VersionLocalizationSettings.vue?vue&type=template&id=2c5200c7&lang=pug&"
import script from "./VersionLocalizationSettings.vue?vue&type=script&lang=js&"
export * from "./VersionLocalizationSettings.vue?vue&type=script&lang=js&"
import style0 from "./VersionLocalizationSettings.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports